const ufeApi = require('services/api/ufeApi');

function smsSubscribe(phoneNumber) {
    return ufeApi.makeRequest('/api/util/OptinEmailSms', {
        method: 'POST',
        body: JSON.stringify({
            phoneNumber,
            type: 'SMS'
        })
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = smsSubscribe;
